import React, { useEffect, useState } from "react";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { useDispatch, useSelector } from "react-redux";
import { usePopup } from "../contexts/PopupContext";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigation } from "../contexts/NavigationContext";
import Enrollment from "./Enrollment";
import GradeOnAssignment from "./GradeOnAssignment";
import GradeOnEnrollment from "./GradeOnEnrollment";
import AddPaymentRecord from "../forms/AddPaymentRecord";

import {
  faPlus,
  faPercent,
  faHandHoldingDollar,
  faEye,
  faTableList,
  faTrashCan,
  faListCheck,
  faMagnifyingGlass,
  faChevronLeft,
  faPen,
  faBook,
  faFileCircleCheck,
  faCertificate,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FormWrapper,
  Label,
  Select,
  Button,
  Input,
} from "./shared_form_styles";
import {
  Wrapper,
  Header,
  NameWrapper,
  Row,
  Column,
  ButtonSection,
  InfoLabel,
  InputName,
  NavButton,
} from "./shared_details_form_styles";
import {
  TableSection,
  H4,
  Table,
  Th,
  Td,
  Tr,
  TableIconButton,
} from "../table_styles";
import { deleteStudent, updateStudent } from "../actions/studentActions";
import { deleteEnrollment } from "../actions/enrollmentActions";
import {
  setSelectedStudent,
  unsetSelectedStudent,
  setSelectedSubjectInstance,
} from "../actions/selectionActions";
import { setSubjects, deleteSubject } from "../actions/subjectActions";
import { setSubjectInstances } from "../actions/subjectInstanceActions";
import styled from "styled-components";
import LoadingSpinner from "../components/LoadingSpinner";
const CurrencySelector = styled(Select)`
  background-color: ${({ disabled }) => (disabled ? "transparent" : "white")};
  color: var(--font-on-background-color);
  &:disabled {
    color: var(--font-on-background-color);
  }
`;
export const Student = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState("");
  const [document, setDocument] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [church, setChurch] = useState("");
  const [education_level, setEducationLevel] = useState("");
  const [age, setAge] = useState("");
  const [studentOfPage, setStudentOfPage] = useState(null);
  const [ocupation, setOcupation] = useState("");
  const [address, setAddress] = useState("");
  const [currency, setCurrency] = useState("");
  const currencies = ["UYU", "ARG", "USD"];

  const selectedStudent = useSelector((state) =>
    state.selection.selectedStudent ? state.selection.selectedStudent : null
  );
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null
  );
  const subjectInstancesArray = useSelector((state) =>
    state.subjectInstances ? state.subjectInstances : null
  );
  const enrollmentsArray = useSelector((state) =>
    state.enrollments ? state.enrollments : null
  );
  const assignmentsArray = useSelector((state) =>
    state.assignments ? state.assignments : null
  );
  const gradesArray = useSelector((state) =>
    state.grades ? state.grades : null
  );
  const subjectsArray = useSelector((state) =>
    state.subjects ? state.subjects : null
  );
  const attendancesArray = useSelector((state) =>
    state.attendances ? state.attendances : null
  );

  const { openPopup } = usePopup();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { navigateTo } = useNavigation();

  useEffect(() => {
    // if (studentsArray.length === 0 || subjectInstancesArray.length === 0) {
    if (studentsArray.length === 0) {
      navigateTo(`students`);
    }
    window.scrollTo(0, 0);
    if (!subjectsArray || subjectsArray?.length == 0) {
      dispatch(setSubjects());
    }
  }, []);
  useEffect(() => {
    if (selectedStudent) {
      const student = studentsArray?.find(
        (st) => st._id == selectedStudent._id
      );
      setName(student.name);
      setDocument(student.document);
      setBirthdate(student.birthdate);
      setCity(student.city);
      setPhone(student.phone);
      setMail(student.mail);
      setChurch(student.church);
      setEducationLevel(student.education_level);
      setOcupation(student.ocupation);
      setAddress(student.address);
      setCurrency(student.currency);
      setStudentOfPage(student);
    }
  }, [selectedStudent, studentsArray]);
  useEffect(() => {
    if (birthdate) {
      setAge(calculateAge(birthdate));
    }
  }, [birthdate]);

  const goBack = () => {
    dispatch(unsetSelectedStudent());
    navigateTo(`students`);
  };
  const calculateAge = (bdate) => {
    const today = new Date();
    const birthdate = new Date(bdate);
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDiff = today.getMonth() - birthdate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthdate.getDate())
    ) {
      age--;
    }
    return age;
  };
  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleSave = () => {
    const updatedStudent = {
      studentId: studentOfPage._id,
      name,
      document,
      birthdate,
      city,
      phone,
      mail,
      church,
      education_level,
      ocupation,
      address,
      currency,
    };
    dispatch(updateStudent(updatedStudent));
    setIsEditing(false);
  };
  const handlePay = () => {
    if (studentOfPage) {
      openPopup(<AddPaymentRecord studentId={id} />);
    }
  };
  const handleEnrollment = () => {
    openPopup(<Enrollment studentId={id} />);
  };
  const handleGradeSubject = (subjectInstance = null) => {
    dispatch(setSelectedStudent(studentOfPage));
    if (!subjectInstance) {
      openPopup(<GradeOnEnrollment studentId={id} />);
    } else {
      dispatch(setSelectedSubjectInstance(subjectInstance));
      openPopup(
        <GradeOnEnrollment
          studentId={id}
          subjectInstanceId={subjectInstance._id}
        />
      );
    }
  };
  const handleGradeAssignment = (subjectInstance) => {
    if (subjectInstance) {
      dispatch(setSelectedSubjectInstance(subjectInstance));
      dispatch(setSelectedStudent(studentOfPage));
      openPopup(
        <GradeOnAssignment
          subjectInstanceId={subjectInstance._id}
          studentId={id}
        />
      );
    } else {
      openPopup(<GradeOnAssignment studentId={id} />);
    }
  };
  const handleDeleteEnrollment = async (enrollmentId) => {
    dispatch(deleteEnrollment(enrollmentId));
  };
  const handleDeleteStudent = (studentId) => {
    dispatch(deleteStudent(studentId));
  };

  const handleEnrollmentEdit = (enrollment) => {
    dispatch(setSelectedSubjectInstance(enrollment.subjectInstance));
    openPopup(
      <Enrollment sutudent={id} edit={true} enrollmentId={enrollment._id} />
    );
  };

  const generatePdf = () => {
    const doc = new jsPDF();
    const headerColor = [96, 3, 3]; // RGB color for #600303

    let currentY = 20; // Initial Y position

    // Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);
    doc.text(`Escolaridad ${studentOfPage.name}`, 14, currentY);
    currentY += 20;

    // Data for "Cursando" table
    const currentSubjects =
      subjectInstancesArray &&
      enrollmentsArray
        .filter((enrollment) => enrollment.student._id === studentOfPage?._id)
        .filter((enrollment) => enrollment.status === "enrolled")
        .map((enrollment) => ({
          name: subjectInstancesArray.find(
            (subjectInstance) =>
              subjectInstance._id === enrollment.subjectInstance._id
          )?.subject.name,
          schedule: enrollment.schedule,
          absences:
            enrollment.attendances ?
              enrollment.attendances.filter((at) => at.status === "Ausente")
                .length
            : 0,
          assignmentGrades:
            assignmentsArray ?
              assignmentsArray
                .filter(
                  (ass) =>
                    ass.subjectInstance?._id === enrollment.subjectInstance._id
                )
                .map((ass, index) =>
                  gradesArray && gradesArray.length > 0 ?
                    gradesArray.find(
                      (gr) =>
                        gr.assignment?._id === ass._id &&
                        gr.student?._id === enrollment.student._id
                    )?.grade || "Pendiente"
                  : "Pendiente"
                )
                .filter(Boolean) // Remove empty strings
                .join(",")
            : "",
        }));

    // Add "Cursando" title and table
    doc.setFontSize(18);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);
    doc.text("Currently Enrolled", 14, currentY);
    currentY += 5; // Gap between title and table

    doc.autoTable({
      startY: currentY,
      head: [["Name", "Schedule", "Absenses", "Assignments Grades"]],
      body: currentSubjects.map((subject) => [
        subject.name,
        subject.schedule,
        subject.absences,
        subject.assignmentGrades,
      ]),
      headStyles: { fillColor: headerColor },
      margin: { top: 10 },
      // didDrawPage: () => {
      //   currentY = doc.autoTable.previous.finalY + 20; // Update currentY for the next table
      // },
    });
    currentY = doc.autoTable.previous.finalY + 10;

    // Data for "Materias Aprobadas" table
    const approvedSubjects =
      subjectInstancesArray &&
      enrollmentsArray
        .filter((enrollment) => enrollment.student._id === studentOfPage?._id)
        .filter(
          (enrollment) =>
            enrollment.status === "completed" && enrollment.grade > 60
        )
        .map((enrollment) => ({
          name: subjectInstancesArray.find(
            (subjectInstance) =>
              subjectInstance._id === enrollment.subjectInstance._id
          )?.subject.name,
          schedule: enrollment.schedule,
          finalGrade: enrollment.grade,
          date: enrollment.modified_date,
        }));

    // Add "Materias Aprobadas" title and table
    doc.setFontSize(18);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);
    doc.text("Aproved Subjects", 14, currentY);
    currentY += 5; // Gap between title and table

    doc.autoTable({
      startY: currentY,
      head: [["Name", "Schedule", "Final Grade", "Date"]],
      body: approvedSubjects.map((subject) => [
        subject.name,
        subject.schedule,
        subject.finalGrade,
        subject.date,
      ]),
      headStyles: { fillColor: headerColor },
      margin: { top: 10 },
      // didDrawPage: () => {
      //   currentY = doc.autoTable.previous.finalY + 20; // Update currentY for the next table
      // },
    });
    currentY = doc.autoTable.previous.finalY + 10;

    // Data for "Materias Reprobadas" table
    const failedSubjects =
      subjectInstancesArray &&
      enrollmentsArray
        .filter((enrollment) => enrollment.student._id === studentOfPage?._id)
        .filter(
          (enrollment) =>
            enrollment.status === "dropped" ||
            (enrollment.status === "completed" && enrollment.grade < 60)
        )
        .map((enrollment) => ({
          name: subjectInstancesArray.find(
            (subjectInstance) =>
              subjectInstance._id === enrollment.subjectInstance._id
          )?.subject.name,
          schedule: enrollment.schedule,
          finalGrade: enrollment.grade,
          date: enrollment.modified_date,
        }));

    // Add "Materias Reprobadas" title and table
    doc.setFontSize(18);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);
    doc.text("Failed Subjects", 14, currentY);
    currentY += 5; // Gap between title and table

    doc.autoTable({
      startY: currentY,
      head: [["Name", "Schedule", "Final Grade", "Date"]],
      body: failedSubjects.map((subject) => [
        subject.name,
        subject.schedule,
        subject.finalGrade,
        subject.date,
      ]),
      headStyles: { fillColor: headerColor },
      margin: { top: 10 },
      // didDrawPage: () => {
      //   currentY = doc.autoTable.previous.finalY + 20; // Update currentY for the next table
      // },
    });
    currentY = doc.autoTable.previous.finalY + 10;

    // Data for "Materias Pendientes" table
    const pendingSubjects =
      studentOfPage &&
      enrollmentsArray &&
      subjectsArray &&
      subjectsArray
        ?.filter(
          (subject) =>
            !enrollmentsArray.some(
              (enrollment) =>
                enrollment.student._id === studentOfPage._id &&
                enrollment.subjectInstance.subject.name === subject.name &&
                enrollment.status === "completed" &&
                enrollment.grade > 60
            )
        )
        .filter((subj) => subj.isMandatory)
        .map((subjectPending) => ({
          name: subjectPending.name,
        }));

    // Add "Materias Pendientes" title and table
    doc.setFontSize(18);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);
    doc.text("Pending Subjects", 14, currentY);
    currentY += 5; // Gap between title and table

    doc.autoTable({
      startY: currentY,
      head: [["Name"]],
      body: pendingSubjects.map((subject) => [subject.name]),
      headStyles: { fillColor: headerColor },
      margin: { top: 10 },
      didDrawPage: () => {
        currentY = doc.autoTable.previous.finalY + 10; // Update currentY
      },
    });

    // Save the PDF
    doc.save(`grades_${studentOfPage.name}.pdf`);
  };

  return (
    <Wrapper>
      <Header>
        <NameWrapper>
          <InputName
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            disabled={!isEditing}
          />

          <InfoLabel
            hasdebt={
              (
                studentOfPage &&
                studentsArray.find((st) => st._id == studentOfPage._id).debt > 0
              ) ?
                "true"
              : "false"
            }
          >
            Debt: {studentOfPage && studentOfPage.currency} ${" "}
            {(
              studentOfPage &&
              studentsArray.find((st) => st._id == studentOfPage._id).debt
            ) ?
              studentOfPage &&
              studentsArray.find((st) => st._id == studentOfPage._id).debt
            : 0}
          </InfoLabel>
        </NameWrapper>

        {!isEditing && (
          <ButtonSection>
            <NavButton onClick={goBack}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </NavButton>
            <Button onClick={() => handleEdit()}>
              <FontAwesomeIcon icon={faPen} />
            </Button>
            {studentOfPage && (
              <Button onClick={() => handlePay()}>
                <FontAwesomeIcon icon={faHandHoldingDollar} />
              </Button>
            )}
            <Button onClick={() => handleEnrollment()}>
              <FontAwesomeIcon icon={faBook} />
            </Button>
            <Button onClick={() => handleGradeSubject()}>
              <FontAwesomeIcon icon={faCertificate} />
            </Button>
            <Button onClick={() => handleGradeAssignment()}>
              <FontAwesomeIcon icon={faListCheck} />
            </Button>
            <Button onClick={() => handleDeleteStudent()}>
              <FontAwesomeIcon icon={faTrashCan} />
            </Button>
            <Button onClick={generatePdf}>
              <FontAwesomeIcon icon={faDownload} />
            </Button>
          </ButtonSection>
        )}
      </Header>
      <Row>
        <Column>
          <Label>
            ID:
            <Input
              type="text"
              name="document"
              value={document}
              onChange={(e) => {
                setDocument(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Birthdate:
            <Input
              type="date"
              name="birthdate"
              value={birthdate ? birthdate.split("T")[0] : ""}
              onChange={(e) => {
                setBirthdate(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Email:
            <Input
              type="text"
              name="mail"
              value={mail}
              onChange={(e) => {
                setMail(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Phone:
            <Input
              type="text"
              name="phone"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Address:
            <Input
              type="text"
              name="address"
              value={address}
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Currrency of Payments:
            <CurrencySelector
              value={currency}
              onChange={(e) => {
                setCurrency(e.target.value);
              }}
              disabled={
                !isEditing ||
                !(
                  studentOfPage &&
                  studentsArray.find((st) => st._id == studentOfPage._id)
                    .debt == 0
                )
              }
            >
              {currencies.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </CurrencySelector>
          </Label>
        </Column>
        <Column>
          <Label>
            City:
            <Input
              type="text"
              name="city"
              value={city}
              onChange={(e) => {
                setCity(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Age:
            <Input
              type="text"
              name="age"
              value={age ? age : ""}
              disabled
              islabel="true"
            />
          </Label>
          <Label>
            Church:
            <Input
              type="text"
              name="church"
              value={church}
              onChange={(e) => {
                setChurch(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Education level:
            <Input
              type="text"
              name="education_level"
              value={education_level}
              onChange={(e) => {
                setEducationLevel(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
          <Label>
            Occupation:
            <Input
              type="text"
              name="ocupation"
              value={ocupation}
              onChange={(e) => {
                setOcupation(e.target.value);
              }}
              disabled={!isEditing}
            />
          </Label>
        </Column>
      </Row>
      {isEditing && <Button onClick={handleSave}>Save</Button>}

      {enrollmentsArray && (
        <>
          <TableSection>
            <H4>Enrolled</H4>
            <Table>
              <thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Schedule</Th>
                  <Th>Absenses</Th>
                  <Th>Assignments Grades</Th>
                  <Th>Actions</Th>
                </Tr>
              </thead>
              <tbody>
                {enrollmentsArray
                  .filter((en) => en.student._id == studentOfPage?._id)
                  .filter((en) => en.status == "enrolled")
                  .map((enrollment, index) => (
                    <Tr key={index}>
                      <Td>
                        {subjectInstancesArray &&
                          subjectInstancesArray.find(
                            (subjectInstance) =>
                              subjectInstance._id ==
                              enrollment.subjectInstance._id
                          )?.subject.name}
                      </Td>
                      <Td>{enrollment.schedule}</Td>
                      {/* <Td>{enrollment.attendances ? enrollment.attendances.filter(at => at.status == 'Ausente').length : 0}</Td> */}
                      <Td>
                        {
                          attendancesArray.filter(
                            (at) =>
                              at.enrollment._id == enrollment._id &&
                              at.status == "Ausente" &&
                              at.enrollment.status == "enrolled"
                          ).length
                        }
                      </Td>
                      <Td>
                        {assignmentsArray ?
                          assignmentsArray
                            .filter(
                              (ass) =>
                                ass.subjectInstance?._id ===
                                enrollment.subjectInstance._id
                            )
                            .map((ass, index) =>
                              gradesArray && gradesArray.length > 0 ?
                                gradesArray.find(
                                  (gr) =>
                                    gr.assignment?._id === ass._id &&
                                    gr.student?._id === enrollment.student._id
                                )?.grade || "Pendiente"
                              : "Pendiente"
                            )
                            .filter(Boolean) // Remove empty strings
                            .join(",")
                        : ""}
                      </Td>
                      <Td>
                        <TableIconButton
                          onClick={() => handleEnrollmentEdit(enrollment)}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() => handleDeleteEnrollment(enrollment._id)}
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() =>
                            handleGradeSubject(enrollment.subjectInstance)
                          }
                        >
                          <FontAwesomeIcon icon={faCertificate} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() =>
                            handleGradeAssignment(enrollment.subjectInstance)
                          }
                        >
                          <FontAwesomeIcon icon={faListCheck} />
                        </TableIconButton>
                      </Td>
                    </Tr>
                  ))}
              </tbody>
            </Table>
          </TableSection>
          <TableSection>
            <H4>Aproved Subjects</H4>
            <Table>
              <thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Schedule</Th>
                  <Th>Final Grade</Th>
                  <Th>Date</Th>
                  <Th>Actions</Th>
                </Tr>
              </thead>
              <tbody>
                {enrollmentsArray
                  .filter((en) => en.student._id == studentOfPage?._id)
                  .filter((en) => en.status == "completed" && en.grade > 60)
                  .map((enrollment, index) => (
                    <Tr key={index}>
                      <Td>
                        {subjectInstancesArray &&
                          subjectInstancesArray.find(
                            (subjectInstance) =>
                              subjectInstance._id ==
                              enrollment.subjectInstance._id
                          )?.subject.name}
                      </Td>
                      <Td>{enrollment.schedule}</Td>
                      <Td>{enrollment.grade}</Td>
                      <Td>{enrollment.modified_date}</Td>
                      <Td>
                        <TableIconButton
                          onClick={() =>
                            handleGradeSubject(enrollment.subjectInstance)
                          }
                        >
                          <FontAwesomeIcon icon={faCertificate} />
                        </TableIconButton>
                      </Td>
                    </Tr>
                  ))}
              </tbody>
            </Table>
          </TableSection>
          <TableSection>
            <H4>Failed Subjects</H4>
            <Table>
              <thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Schedule</Th>
                  <Th>Final Grade</Th>
                  <Th>Date</Th>
                  <Th>Actions</Th>
                </Tr>
              </thead>
              <tbody>
                {enrollmentsArray
                  .filter((en) => en.student._id == studentOfPage?._id)
                  .filter(
                    (en) =>
                      en.status == "dropped" ||
                      (en.status == "completed" && en.grade < 60)
                  )
                  .map((enrollment, index) => (
                    <Tr key={index}>
                      <Td>
                        {subjectInstancesArray &&
                          subjectInstancesArray.find(
                            (subjectInstance) =>
                              subjectInstance._id ==
                              enrollment.subjectInstance._id
                          )?.subject.name}
                      </Td>
                      <Td>{enrollment.schedule}</Td>
                      <Td>{enrollment.grade}</Td>
                      <Td>{enrollment.modified_date}</Td>
                      <Td>
                        <TableIconButton
                          onClick={() =>
                            handleGradeSubject(enrollment.subjectInstance)
                          }
                        >
                          <FontAwesomeIcon icon={faCertificate} />
                        </TableIconButton>
                      </Td>
                    </Tr>
                  ))}
              </tbody>
            </Table>
          </TableSection>

          <TableSection>
            <H4>Pending Subjects</H4>
            <Table>
              <thead>
                <Tr>
                  <Th>Name</Th>
                </Tr>
              </thead>
              <tbody>
                {studentOfPage &&
                  enrollmentsArray &&
                  subjectsArray &&
                  subjectsArray
                    ?.filter(
                      (subject) =>
                        !enrollmentsArray.some(
                          (enrollment) =>
                            enrollment.student._id == studentOfPage._id &&
                            enrollment.subjectInstance.subject.name ===
                              subject.name &&
                            enrollment.status == "completed" &&
                            enrollment.grade > 60
                        )
                    )
                    .filter((subj) => subj.isMandatory)
                    .map((subjectPending, index) => (
                      <Tr key={index}>
                        <Td>{subjectPending.name}</Td>
                      </Tr>
                    ))}
              </tbody>
            </Table>
          </TableSection>
        </>
      )}
    </Wrapper>
  );
};

export default Student;
